<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            @row-clicked="onRowClicked"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
            <template #cell(semesters)="row">
                <span class="d-flex align-items-center">{{ getLocaleText(row.item, 'semesters') }}</span>
            </template>
            <template #cell(steps)="row">
                <span class="d-flex align-items-center justify-content-center" style="cursor:pointer">
                    <i class="ri-arrow-down-s-line"></i>
                </span>
            </template>
            <template v-slot:cell(active_approver)="{item}">
                <div v-if="item.active_step?.name">
                    {{ getLocaleText(item.active_step, 'name') }}
                </div>
                <div v-else-if="item.active_step">
                    <span v-for="(approver, index) in item.active_step.approvers" :key="index">
                        {{ getLocaleText(approver, 'explanation') }}
                        <span v-if="index < item.active_step.approvers.length - 1">, </span>
                    </span>
                </div>
            </template>
            <template #row-details="data">
                <b-table-simple responsive small class="table-bordered table-striped table-sm">
                    <thead>
                        <tr>
                            <th class="text-center">{{ $t('rank').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('can_approvers').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('approved_by').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('status').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('explanation').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('updated_at').toUpperCase() }}</th>
                        </tr>
                    </thead>
                    <b-tbody v-for="(item, i) in data.item.steps" :key="i">
                        <tr>
                            <td class="text-center">{{ i + 1 }}</td>
                            <td>
                                <div v-for="(approver, idx) in item.approvers" :key="idx">
                                    {{ getLocaleText(approver, 'explanation') }}
                                </div>
                            </td>
                            <td>
                                <div v-for="(approved, idx) in (getObjectValue(item, 'approved', []))" :key="idx">
                                    {{ getObjectValue(approved, 'name') + ' ' + getObjectValue(approved, 'surname') }}
                                </div>
                            </td>
                            <td>{{ getLocaleText(item, 'status_name') }}</td>
                            <td>{{ getObjectValue(item, 'reason') }}</td>
                            <td>{{ IsoDate(item.updated_at) }}</td>
                        </tr>
                    </b-tbody>
                </b-table-simple>
            </template>
        </b-table>
    </div>
</template>

<script>
import LeaveOfAbsenceService from "@/services/LeaveOfAbsenceService";
import moment from 'moment';

/**
 * Leave of Absence Tab Component
 * Handles student's leave of absence requests.
 */
export default {
    name: 'LeaveOfAbsenceTab',
    data() {
        return {
            items: [],
            fields: [
                { key: 'steps', label: '' },
                {
                    key: this.getLocaleField('program_name'),
                    label: this.toUpperCase('program'),
                },
                { key: 'academic_year', label: this.toUpperCase('academic_year') },
                { key: 'semesters', label: this.toUpperCase('semester') },
                { key: this.getLocaleField('reason_name'), label: this.toUpperCase('reason') },
                { key: 'explanation', label: this.toUpperCase('explanation') },
                { key: 'created_at', label: this.toUpperCase('date') },
                { key: 'active_approver', label: this.toUpperCase('at_which_unit') },
                { key: this.getLocaleField('status_name'), label: this.toUpperCase('status') },
            ],
        };
    },
    methods: {
        /**
         * Fetch leave of absence requests from service
         */
        fetchData() {
            LeaveOfAbsenceService.studentRequests()
                .then(response => {
                    this.items = response.data.data;
                    this.items.forEach(item => {
                        if (item.active_step && item.active_step.approvers) {
                            let arr = [];
                            item.active_step.approvers.forEach(approver => {
                                arr.push(this.getLocaleText(approver, 'explanation'));
                            });
                            item.active_approver = arr.join(', ');
                        }
                    });
                })
                .catch(e => {
                    this.showErrors(e);
                });
        },
        /**
         * Handle row click to show details
         */
        onRowClicked(item) {
            this.$set(item, '_showDetails', !item._showDetails);
        },
        /**
         * Format ISO date
         */
        IsoDate(date) {
            return moment(date).utc().format("YYYY-MM-DD HH:mm");
        }
    },
    created() {
        this.fetchData();
    }
};
</script>
